import AudioPlayer, {
  ProgressUI,
  VolumeSliderPlacement,
  ActiveUI,
} from 'react-modern-audio-player'
import { useState } from 'react'
import { playList } from './Playlist'

function Player() {
  const [progressType, setProgressType] = useState<ProgressUI>('waveform')
  const [volumeSliderPlacement, setVolumeSliderPlacement] =
    useState<VolumeSliderPlacement>()
  const [activeUI, setActiveUI] = useState<ActiveUI>({ all: true })

  return (
    <div className="masteraudioplayer">
      <AudioPlayer
        playList={playList}
        activeUI={{
          ...activeUI,
          progress: progressType,
        }}
      />
    </div>
  )
}

export default Player
